import * as React from "react"
import './haul.scss'
import like from '@/images/like.png'
import { getHaulComment } from '@/service/api'
import { useEffect, useState, useRef } from "react"
import SEO from './seo'
import { isBrowser } from "@/lib/utils"
import Loading from '@/layouts/Loading'

const Haul = (props: any) => {
  const propsHaulData = props.pageContext.haulData
  const [isPC, setIsPC] = useState(isBrowser ? document.body.clientWidth >= 960 : true)
  const [active, setActive] = useState(0);
  const waterfallRef = useRef(null)
  const [showLoading, setShowLoading] = useState(false)

  const tabs = [
    {
      "categoryName": "推荐",
      "categoryId": "RECOMMEND"
    },
    {
      "categoryName": "女包",
      "categoryId": "WOMEN_BAG"
    },
    {
      "categoryName": "配饰",
      "categoryId": "ACCESSORIES"
    },
    {
      "categoryName": "美护",
      "categoryId": "BEAUTY"
    },
    {
      "categoryName": "女鞋",
      "categoryId": "WOMEN_SHOES"
    },
    {
      "categoryName": "女装",
      "categoryId": "WOMEN_CLOTH"
    },
    {
      "categoryName": "男鞋",
      "categoryId": "MEN_SHOES"
    },
    {
      "categoryName": "婴童",
      "categoryId": "CHILD"
    },
    {
      "categoryName": "男装",
      "categoryId": "MEN_CLOTH"
    },
    {
      "categoryName": "健康",
      "categoryId": "HEALTH"
    },
    {
      "categoryName": "生活",
      "categoryId": "LIFE"
    }
  ]

  let _propsHaulData: any[] = []
  propsHaulData.map((item: any, key: number) => {
    const remain = isPC ? key % 5 : key % 2
    if (!_propsHaulData[remain]) {
      _propsHaulData[remain] = []
    }
    _propsHaulData[remain].push(item)
  })
  const [haulData, setHaulData] = useState<any[]>(_propsHaulData)
  const [f, setFrom] = useState(0)
  const size = 30

  function handleClick(item: any) {
    setActive(item);
    setFrom(0)
    window.scrollTo(0, 0)
  }

  React.useEffect(() => {
    window.scrollTo(0, 0)
    setIsPC(document.body.clientWidth >= 960)
  }, [isPC])

  useEffect(() => {
    if (!f) {
      return
    }
    // startLoading
    setShowLoading(true)
    getHaulComment(f * size, size, active === 0 ? 0 : tabs?.[active]?.categoryId)
      .then((res: any) => {
        const _haulData = [...haulData];
        const data = res.waterFall?.waterDrops;
        if (data && data.length) {
          data.map((item: any, key: number) => {
            const remain = isPC ? key % 5 : key % 2
            _haulData[remain].push(item)
          })
          setHaulData(_haulData)
        }
        setShowLoading(false)
      })
  }, [f])

  useEffect(() => {
    setShowLoading(true)
    getHaulComment(f * size, size, active === 0 ? 0 : tabs?.[active]?.categoryId)
      .then((res: any) => {
        let _haulData: any = [];
        const data = res.waterFall?.waterDrops;
        if (data && data.length) {
          data.map((item: any, key: number) => {
            const remain = isPC ? key % 5 : key % 2
            if (!_haulData[remain]) {
              _haulData[remain] = []
            }
            _haulData[remain].push(item)
          })
          setHaulData(_haulData)
        }
        setShowLoading(false)
      })
  }, [active])

  useEffect(() => {
    if (isPC) return
    // 移动端滚动自动加载
    window.addEventListener('scroll', () => {
      if (waterfallRef.current && waterfallRef.current && !showLoading) {
        const scrollTop = window.pageYOffset
        const menu: HTMLElement = waterfallRef.current
        const windowHeight = window.innerHeight
        const { height: menuHeight } = menu.getBoundingClientRect()
        if (scrollTop + windowHeight > menuHeight) {
          getMore()
        }
      }
    })

    return window.removeEventListener('scroll', () => { })
  }, [f])

  const getMore = () => {
    setFrom(f + 1)
  }
  return (
    <article className="p-haul">
      <SEO
        title={'别样海外购_用户晒单频道 | 别样海外购 bieyangapp.com'}
        description={'别样海外购_用户晒单频道 | 别样海外购 bieyangapp.com'}
        keywords={'别样海外购_用户晒单频道 | 别样海外购 bieyangapp.com'}
      />
      {showLoading && <Loading />}
      <div className='tab-wrap'>
        {tabs?.map((item: any, idx: number) => {
          const isActive = idx === active;
          return (<div className='tab-wrap-main' key={item.categoryId}>
            <div
              className={`tab-item ${isActive ? 'active' : ''}`}
              onClick={() => handleClick(idx)}
            >
              {item.categoryName}
            </div>
            {idx !== tabs.length - 1
              ? <div className='tab-item-split'></div>
              : <></>
            }
          </div>
          )
        })}
      </div>
      <div className="waterfall" ref={waterfallRef}>
        {
          haulData?.map((haul: any, key: number) => {
            return <div className='waterfall-item' key={key}>
              {
                haul.map((item: any, idx: number) => {
                  return <div className='waterfall-item-content' key={`${key}_${idx}`}>
                    <a href={`https://baleen-cdn-g.bybieyang.com/static/html/byh5-comment/index.html?productId=${item.productId}&commentId=${item.commentId}`}>
                      <img className='waterfall-item-content-img' src={item?.image?.thumbnail?.url || item?.image?.full?.url} alt="晒单图片" />
                      <p className='waterfall-item-content-content'>{item.content}</p>
                      <div className='waterfall-item-content-bottom'>
                        <div className='waterfall-item-content-bottom-left'>
                          <div className='waterfall-item-content-bottom-left-avatar'>
                            <img src={item.userAvatar} alt="头像" />
                          </div>
                          <span>{item.userLabel}</span>
                        </div>
                        <div className='waterfall-item-content-bottom-right'>
                          <img src={like} alt="喜欢的icon" />
                          <span>{item.likes}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                })
              }
            </div>
          })
        }
      </div>
      <div className='getMore' onClick={getMore}>查看更多</div>
    </article>
  )
}
export default Haul
